<script setup lang="ts">
import type { Column, Action } from '../types'
import { cn } from '@/lib/utils'
import { verticalAlignClasses, horizontalAlignClasses, getColumnWidthClass } from '../utils/classes'
import ACElement from './ACElement.vue'

const props = defineProps<{
  element: Column
  onAction?: (action: Action, inputs: Record<string, string>) => void
}>()
</script>

<template>
  <div
    :class="cn(
      'flex flex-col [&>*:first-child]:mt-0',
      getColumnWidthClass(props.element.width),
      props.element.horizontalAlignment && horizontalAlignClasses[props.element.horizontalAlignment],
      props.element.verticalContentAlignment && verticalAlignClasses[props.element.verticalContentAlignment]
    )"
  >
    <ACElement
      v-for="(item, index) in props.element.items"
      :key="index"
      :element="item"
      :on-action="props.onAction"
    />
  </div>
</template>
